<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container agree">
      <div class="hh1">{{ $t('agreementpage.text1') }}</div>
      <p>{{ $t('agreementpage.text2') }}</p>
      <div class="hh2">1. {{ $t('agreementpage.text3') }}</div>
      <p>
        {{ $t('agreementpage.text4') }}
      </p>
      <div class="hh2">2. {{ $t('agreementpage.text5') }}</div>
      <p>{{ $t('agreementpage.text6') }}</p>
      <div class="hh2">3. {{ $t('agreementpage.text7') }}</div>
      <p>{{ $t('agreementpage.text8') }}</p>
      <ul>
        <li>･ {{ $t('agreementpage.text9') }}</li>
        <li>･ {{ $t('agreementpage.text10') }}</li>
        <li>･ {{ $t('agreementpage.text11') }}</li>
        <li>･ {{ $t('agreementpage.text12') }}</li>
        <li>･ {{ $t('agreementpage.text13') }}</li>
        <li>･ {{ $t('agreementpage.text14') }}</li>
        <li>･ {{ $t('agreementpage.text15') }}</li>
        <li>･ {{ $t('agreementpage.text16') }}</li>
        <li>･ {{ $t('agreementpage.text17') }}</li>
        <li>･ {{ $t('agreementpage.text18') }}</li>
        <li>･ {{ $t('agreementpage.text19') }}</li>
        <li>･ {{ $t('agreementpage.text20') }}</li>
        <li>･ {{ $t('agreementpage.text21') }}</li>
        <li>･ {{ $t('agreementpage.text22') }}</li>
        <li>･ {{ $t('agreementpage.text23') }}</li>
      </ul>
      <div class="hh2">4. {{ $t('agreementpage.text24') }}</div>
      <p>
        {{ $t('agreementpage.text25') }}
      </p>
      <Resource />
    </div>
  </div>
</template>
<script>
import Resource from '@/components/Resource'

export default {
  name: 'UserAgreement',
  components: {
    Resource
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.agree {
  font-family: 'Montserrat';
  font-weight: bold;
  font-size: 0.1rem;
  color: #7e7e7e;
  .hh1 {
    font-size: 0.12rem;
    color: #ffffff;
    margin: 0.2rem 0;
  }
  .hh2 {
    color: #ffffff;
    margin: 0.22rem 0 0.1rem;
  }
  br {
    margin-bottom: 0.1rem;
  }
  ul {
    li {
      margin: 0.1rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/agreement.vue